// tslint:disable-next-line:ban-types
export function wait(ms: number, callback?: Function) {
	return new Promise((resolve) => {
		setTimeout(async () => {
			if(callback) {
				await callback()
			}
			resolve(1)
		}, ms)
	})
}
